import React, { useState, useEffect } from 'react';
import OtpInput from 'react-otp-input';
import {
  API_CODE,
  ENVIRONMENT_VARIABLES,
  MUI_COLORS,
  REQUIRED_LENGTH,
  SENDGRID_DETAILS,
  SSO_BASE_API_URL,
  TYPE_OF_OTP,
  MARKETING_LOGIN_URL
} from '../../constants/enum';
import '../../styles/verifyOtpInput.scss';
import ValidationMessage from '../ui/ValidationMessage';
import { connect } from 'react-redux';
import * as OtpActions from './reduxStore/action';
import * as userActions from '../invoice/reduxStore/action';
import * as LoginActions from '../login/reduxStore/action';
import PropTypes from 'prop-types';
import { PATH_PAGE } from '../../routes/paths';
import { navigate } from 'gatsby';
import { handleLogin } from '../authService/auth';
import { useLocation } from '@reach/router';
import { isBrowser, sendHubspotRequest } from '../../helper/helpers';
import { ENDPOINTS } from '../../service/services';
import axios from 'axios';
function VerifyOtpInput({
  email,
  fromForgotPassword,
  emailForConfirmation,
  fromResendCode,
  getInvoiceGenerator,
  updateUserInvoiceGenerator,
  sendToSendGridContacts,
  signUpDetails,
  updateSSOToken
}) {
  const [otp, setOtp] = useState('');
  const [error, setOtpError] = useState('');
  const [isTemporary, setIsTemporary] = useState(false);
  const [invoiceGeneratorData, setInvoiceGeneratorData] = useState('');
  const location = useLocation();

  const handleChange = async (otpValue) => {
    setOtp(otpValue);
    if (otpValue.length === REQUIRED_LENGTH.OTP_LENGTH) {
      let payload = {
        email: fromForgotPassword || fromResendCode ? emailForConfirmation : email,
        otp: otpValue,
        type: fromForgotPassword
          ? TYPE_OF_OTP?.FORGOT_PASSWORD
          : fromResendCode
          ? TYPE_OF_OTP?.RESEND_CODE
          : TYPE_OF_OTP?.SIGN_UP,
        password: signUpDetails?.password
      };
      try {
        const otpResponse = await axios.put(`${SSO_BASE_API_URL}${ENDPOINTS.SSO_VERIFY_OTP}`, payload);
        if (otpResponse?.status === API_CODE?.STATUS_200) {
          fromForgotPassword
            ? navigate(PATH_PAGE?.resetPassword, {
                state: { emailForResetPassword: emailForConfirmation, otpForResetPassword: otpValue }
              })
            : isTemporary
            ? invoiceGeneratorData && handleUpdateUserTempInvoice(invoiceGeneratorData, otpResponse?.data?.data)
            : handleRedirection(otpResponse);
          if (process.env.ENVIRONMENT === ENVIRONMENT_VARIABLES.PRODUCTION) {
            !fromForgotPassword && (await sendEmailToSendGridContacts(email));
          }
          !fromForgotPassword && (await sendHubspot(email));
        } else {
          setOtpError(otpResponse?.data?.message);
        }
      } catch (error) {
        setOtpError(error?.response?.data?.message);
      }
    }
  };

  const handleRedirection = (otpResponse) => {
    singleSignOnhandler(otpResponse?.data?.data);
  };

  const singleSignOnhandler = async (otpApiResponse) => {
    if (otpApiResponse?.token && otpApiResponse?.companyId) {
      const payload = {
        companyId: otpApiResponse?.companyId
      };
      const updateSSOTokenResponse = await updateSSOToken(payload, otpApiResponse?.token);
      if (updateSSOTokenResponse?.status === API_CODE.STATUS_200) {
        isBrowser() && sessionStorage.setItem('token', updateSSOTokenResponse?.data?.data?.token);
        isBrowser() && sessionStorage.setItem('userCode', updateSSOTokenResponse?.data?.data?.userCode);
        isBrowser() && sessionStorage.setItem('companyId', otpApiResponse?.companyId);
        handleLogin(updateSSOTokenResponse?.data?.data?.token, updateSSOTokenResponse?.data?.data);
      } else {
        navigate(MARKETING_LOGIN_URL, { replace: true });
      }
    } else {
      navigate(MARKETING_LOGIN_URL, { replace: true });
    }
  };

  async function sendEmailToSendGridContacts(email) {
    let sendGridPayload = {
      sendGrid: {
        list_ids: [SENDGRID_DETAILS.LIST_IDS],
        contacts: [{ email: email }]
      }
    };
    await sendToSendGridContacts(sendGridPayload);
  }

  async function sendHubspot(email) {
    let hubspotPayload = {
      fields: [
        {
          name: 'email',
          value: email
        }
      ],
      context: {
        pageUri: `${process.env.SITE_URL}/verify-email`,
        pageName: 'Invoice signup verify OTP'
      }
    };
    sendHubspotRequest({
      formId: process.env.HUBSPOT_FORM_ID,
      hubspotPayload
    });
  }

  const handleUpdateUserTempInvoice = async (invoiceGeneratorData, otpResponse) => {
    const payload = {
      invoiceId: invoiceGeneratorData?._id,
      userId: otpResponse?._id
    };
    const updatedUserTempInvoice = await updateUserInvoiceGenerator(payload);
    if (updatedUserTempInvoice?.status === API_CODE.STATUS_200) {
      handleLogin(otpResponse?.token, otpResponse);
    }
  };

  const getTempInvoiceData = async (invoiceId) => {
    const getInvoiceGeneratorResponse = await getInvoiceGenerator(invoiceId);
    if (getInvoiceGeneratorResponse?.status === API_CODE.STATUS_200) {
      setInvoiceGeneratorData(getInvoiceGeneratorResponse?.data?.data);
    }
  };

  useEffect(() => {
    if (location?.state?.isTemporary && location?.state?.invoiceId) {
      setIsTemporary(true);
      getTempInvoiceData(location?.state?.invoiceId);
    }
  }, []);

  const handleClickCapture = () => {
    if (error) {
      setOtp('');
      setOtpError('');
    }
  };

  return (
    <div onClickCapture={handleClickCapture}>
      <OtpInput
        value={otp}
        onChange={handleChange}
        numInputs={6}
        isInputNum={true}
        shouldAutoFocus={true}
        separator={<span className="ml-2"></span>}
        inputStyle={error ? 'otp-input-error' : 'otp-input'}
        focusStyle={{
          border: error ? '1px solid #FF4F42' : '1px solid #2D0D45',
          background: error ? MUI_COLORS.LIGHT_CREAM : MUI_COLORS.WHITE,
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.16)',
          outline: 'none'
        }}
      />
      {error && <ValidationMessage title={error} />}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    email: state?.signupReducer?.signupDetails?.data?.email,
    signUpDetails: state?.signupReducer?.signUpData
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getInvoiceGenerator: (invoiceData) => dispatch(userActions.getInvoiceGenerator(invoiceData)),
    updateUserInvoiceGenerator: (invoiceData) => dispatch(userActions.updateUserInvoiceGenerator(invoiceData)),
    sendToSendGridContacts: (contacts) => dispatch(OtpActions.sendContacts(contacts)),
    updateSSOToken: (payload, token) => dispatch(LoginActions.updateSSOToken(payload, token))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyOtpInput);

VerifyOtpInput.propTypes = {
  email: PropTypes.string,
  fromForgotPassword: PropTypes.bool,
  emailForConfirmation: PropTypes.string,
  fromResendCode: PropTypes.bool,
  getInvoiceGenerator: PropTypes.func,
  updateUserInvoiceGenerator: PropTypes.func,
  sendToSendGridContacts: PropTypes.func
};
